import { VIEW_CLAIMS } from '@/common/permissionConstants';

export default [
    {
        path: 'financial/:id?/:activeDialog?/:activeId?/:activeGroupId?',
        name: 'financial-page',
        meta: { hasPermission: VIEW_CLAIMS },
        component: () => import('../views/FinancialDashboard'),
        props: true,
    },
];
